'use client';

import PartnerLoginForm from './PartnerLoginForm';
import Link from 'next/link';
import styles from './partnerLoginContent.module.scss';
import { usePartnerAccountRedirect } from '@/hooks/usePartnerAccountRedirect';
import { useSearchParams } from 'next/navigation';
import { Alert } from '@goodneighbor/ui';

export default function PartnerLoginContent() {
  usePartnerAccountRedirect();

  const searchParams = useSearchParams();
  const showPasswordAlert = searchParams.get('alert') === 'password_set';

  return (
    <main className={styles.main}>
      {showPasswordAlert && (
        <Alert
          color="success"
          title="Password already set"
          description="You already have a password set. Please log in below to access your partner dashboard."
          className={styles.alert}
        />
      )}
      <div className={styles.header}>
        <h1 className={styles.title}>Welcome back</h1>
        <p className={styles.subtitle}>Let&apos;s keep doing Good, together.</p>
      </div>
      <PartnerLoginForm />
      <div className={styles.footer}>
        Don&apos;t have an account?{' '}
        <Link href="/partner/sign-up" className={styles.signupLink}>
          Sign up
        </Link>
      </div>
    </main>
  );
}
